import React from "react";
import "./Academia.css";
import imageJoan from "../../Assets/meetjoan.webp";

const MeetJoan = () => {
   return (
      <section className="meet-container">
         {/* Columna Izquierda: Imagen y Stats */}
         <div className="imageColumn">
            <div className="imageWrapper">
               <img
                  src={imageJoan}
                  alt="Joan Company - Creador de Contenido FPV"
                  title="Joan Company - Creador de Contenido FPV"
                  className="meet-profileImage"
               />
               <div className="statsOverlay">
                  {/* <div className="statItem">
                        <span className="statValue">500M+</span>
                        <span className="statLabel">Visualizaciones</span>
                    </div>
                    <div className="statItem">
                        <span className="statValue">456K</span>
                        <span className="statLabel">Instagram</span>
                    </div>
                    <div className="statItem">
                        <span className="statValue">317K</span>
                        <span className="statLabel">TikTok</span>
                    </div>
                    <div className="statItem">
                        <span className="statValue">55K</span>
                        <span className="statLabel">YouTube</span>
                    </div> */}
               </div>
            </div>
         </div>

         {/* Columna Derecha: Texto */}
         <div className="contentColumn">
            <div className="textContent">
               <h2 className="meet-title">CONOCE A JOAN</h2>
               <p className="meet-description">
                  Soy Joan Company, piloto profesional de drones y creador de
                  contenido con drones FPV.
               </p>
               <p className="meet-description">
                  Tras años compitiendo a nivel internacional en ligas de drones
                  de primer nivel, decidí enfocar mi destreza en el{" "}
                  <strong>FPV Cinematográfico</strong>. 
               </p>
               <p className="meet-description">
                  Mi trabajo no consiste
                  solo en volar, consiste en narrar historias a través de planos
                  imposibles. Esta profesión me ha permitido trabajar en sitios
                  como Abu Dhabi y colaborar con marcas referentes del sector
                  como iFlight.
               </p>
            </div>
         </div>
      </section>
   );
};

export default MeetJoan;
